import styled, { css } from 'styled-components'
import { media } from '../../../../layouts/utils'
import { colorBrandPrimary, colorNeutral, fontFamily } from 'src/global.style';
export const Container = styled.div`
  position: relative;
  padding: 2.5rem 1.5rem 2.9rem 1.5rem;
  background-color: #f7f7fc;
  ${media.phone`
    position: static;
  `}
`;

export const Title = styled.div`
  width: 100%;
  color: ${colorBrandPrimary.blue};
  font-family: "Platform Web";
  font-size: min(7vw, 3rem);
  font-weight: 500;
  letter-spacing: 0rem;
  line-height: 4.525rem;
  text-align: center;
  padding: 2rem 1.5rem 0;
  ${media.phone`
    font-size: 28px;
    padding: 0;
  `}
`;

export const ContainerPlan = styled.div`
  z-index: 1;
  margin: 0 60px;
  background: #fff;
  border-width: 2px;
  border-radius: 1rem;
  overflow: hidden;
  opacity: 1;
  padding: 30px 0;
  ${media.phone`
    margin: 0;
    border: 3px solid #FFFFFF;
  `}
`;

export const Sorriso = styled.div`
  width: 100%;
  height: 30px;
  background-image: ${(props) =>
    props.dark
      ? `url("/unidasseminovos/assets/img-simplifique2.png")`
      : `url("/unidasseminovos/assets/img-simplifique.png")`};
  background-repeat: no-repeat;
  background-position-x: center;
  margin-bottom: 20px;
`;

export const Plans = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  width: 100%;
  z-index: 5;
  @media (max-width: 768px) {
    overflow: scroll;
    justify-content: ${({ size }) => (size > 1 ? "initial" : "center")};
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const Modal = styled.div`
  position: absolute;
  bottom: ${({ isError }) => (isError ? "5.65rem" : "6.25rem")};
  left: 0;
  right: 0;
  margin: auto;
  z-index: 10;
  max-width: 37.5rem;
  width: 100%;
  background-color: ${({ backgroundColor }) => backgroundColor};
  padding: 2.25rem 2rem;
  border-radius: 1rem;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  display: ${({ open }) => (open ? "flex" : "none")};
  @media (max-width: 767px) {
    width: 90%;
    bottom: -18rem;
  }
  ${media.phone`
    z-index: 3;
	`}
`;
export const ModalTitle = styled.div`
  font-size: 2rem;
  font-family: "Platform Web";
  color: ${({ color }) => color};
  width: 100%;
  ${media.phone`
    line-height: 35px;

  `}
`;

export const ModalDescription = styled.div`
  width: 100%;
  font-size: 1rem;
`;

export const ModalInput = styled.input`
  width: 100%;
  height: 3.75rem;
  background: white;
  padding: 1rem;
  border-radius: 10px;
  border: none;
`;

export const ModalLinkContainer = styled.div`
  display: flex;
  width: 100%;
  padding: ${({ isError, isMobile }) =>
    isError ? "20px 0 0" : isMobile ? "0px" : "20px 0"};
`;

export const ModalLink = styled.b`
  margin-right: 8px;
  font-size: 16px;
  font-weight: normal;
  text-decoration: underline;
  color: #fff;
  cursor: pointer;
`;

export const ModalLinkContent = styled.div`
  display: flex;
`;

const buttonEnabled = css`
  cursor: pointer;
  color: ${({ color }) => color};
  &:hover {
    min-width: 106px;
    //to balance new height colateral
    margin-right: -0.5rem;
    //to balance side padding collateral
    transition: 0.2s;
    transform: translateY(-0.25rem);
  }
`;

const buttonDisabled = css`
  cursor: not-allowed;
  background: ${({ backgroundColor }) => backgroundColor} !important;
  color: ${({ color }) => color};
  opacity: 0.6;
`;

export const Button = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  width: 145px;
  height: 53px;
  font-size: 1rem;
  transition: all 0.1s ease-in 0s;
  border-radius: 9999px;
  text-align: center;
  font-weight: bold;
  color: ${colorNeutral.light};
  background: #FF2832;
  ${({ disabled }) => (disabled ? buttonDisabled : buttonEnabled)}
  @media (max-width: 768px) {
    width: 129px;
    height: 49px;
  }
  ${media.phone`
    width: 104px;
    height: 49px;
  `}

`;

export const ErrorText = styled.div`
  width: 100%;
  font-size: 0.9rem;
  font-family: ${fontFamily.brand};
`;

export const LoadingCupom = styled.img`
  width: 2rem;
`;

export const IconButton = styled.button`
  background-color: transparent;
  border: none;
  box-shadow: none;
  pointer-events: ${({ disabled }) => disabled && "none"};
`;
